import * as Actions from '../../../Modules/CmsActions'

const initialState = {
  edit: null,
  loading: true,
  updating: false,
  success: false,
  form: 'profile',
}

const UIProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.REQUEST_FETCH_PROFILE:
      return loading(state)

    case Actions.FINISH_FETCH_PROFILE:
      return updateEditInfoWithLoaded(state, action.payload.profile.profileData)

    case Actions.REQUEST_UPDATE_PROFILE:
      return updating(state)

    case Actions.FINISH_UPDATE_PROFILE:
      return successEdit(state)

    case Actions.RESET_UPDATE_PROFILE_STATUS:
      return resetSuccess(state)

    case Actions.REQUEST_UPDATE_PROFILE_EMAIL:
      return updating(state)

    case Actions.INTERRUPT_LOADING:
      return interruptUpdating(state)

    case Actions.LOGOUT:
      return initialState

    default:
      return state
  }
}

function loading(state) {
  return { ...state, loading: true }
}

function loaded(state) {
  return { ...state, loading: false }
}

function updateEditInfoWithLoaded(state, profile) {
  const nameFormValues = { id: profile.id, name: profile.name }
  const emailFormValues = { id: profile.id, email: profile.email }
  const passwordFormValues = { id: profile.id }
  const emailAuthFormValues = { id: profile.id, tmp_email: profile.tmp_email }
  const autoReplyEmailFormValues = {
    id: profile.id,
    is_notifiable: profile.is_notifiable,
  }
  const updated = {
    ...state,
    edit: profile,
    nameFormValues,
    emailFormValues,
    passwordFormValues,
    emailAuthFormValues,
    autoReplyEmailFormValues,
  }
  return loaded(updated)
}

function updating(state) {
  return { ...state, updating: true }
}

function successEdit(state) {
  const succeed = { ...state, success: true, updating: false }
  return loaded(succeed)
}

function resetSuccess(state) {
  return { ...state, success: false }
}

function interruptUpdating(state) {
  const updatedState = { ...state, updating: false }
  return loaded(updatedState)
}

export default UIProfileReducer
